import { render, staticRenderFns } from "./HomeLawMasterQuestion.vue?vue&type=template&id=1526df99&scoped=true"
import script from "./HomeLawMasterQuestion.vue?vue&type=script&lang=js"
export * from "./HomeLawMasterQuestion.vue?vue&type=script&lang=js"
import style0 from "./HomeLawMasterQuestion.vue?vue&type=style&index=0&id=1526df99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526df99",
  null
  
)

export default component.exports